import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  collection,
  limit,
  onSnapshot,
  orderBy,
  query,
} from "firebase/firestore";
import { db } from "../../firebase";
import PageHeader from "../../components/PageHeader";

type Flagged = {
  uid: string;
  reportCount: number;
  reasons: string[];
  flaggedAtMs: number;
};

export default function Flagged() {
  const [rows, setRows] = useState<Flagged[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsub = onSnapshot(
      query(
        collection(db, "moderation", "flagged", "users"),
        orderBy("flaggedAt", "desc"),
        limit(100)
      ),
      (snap) => {
        setRows(
          snap.docs.map((d) => {
            const x = d.data();
            return {
              uid: d.id,
              reportCount: Number(x.reportCount ?? 0),
              reasons: (x.reasons as string[]) ?? [],
              flaggedAtMs: x.flaggedAt?.toMillis?.() ?? Date.now(),
            };
          })
        );
        setLoading(false);
      },
      (err) => {
        console.error(err);
        setLoading(false);
      }
    );
    return unsub;
  }, []);

  return (
    <div>
      <PageHeader
        title="Otomatik işaretli oyuncular"
        subtitle="14 gün içinde 5+ farklı kullanıcı tarafından raporlananlar"
      />

      {loading ? (
        <div className="card p-8 text-textMuted">Yükleniyor…</div>
      ) : rows.length === 0 ? (
        <div className="card p-10 text-center">
          <div className="text-5xl mb-2">🌸</div>
          <div className="font-extrabold text-lg mb-1">Temiz</div>
          <div className="text-sm text-textMuted">
            Eşik aşan kullanıcı yok.
          </div>
        </div>
      ) : (
        <div className="card divide-y divide-stroke/70">
          {rows.map((f) => (
            <Link
              key={f.uid}
              to={`/admin/users/${f.uid}`}
              className="flex items-center gap-4 p-4 hover:bg-surfaceHigh/50 transition"
            >
              <div className="h-10 w-10 rounded-full bg-warning/20 border border-warning/40 grid place-items-center">
                ⚠️
              </div>
              <div className="min-w-0 flex-1">
                <div className="font-semibold font-mono text-sm truncate">
                  {f.uid}
                </div>
                <div className="text-xs text-textMuted mt-0.5 flex flex-wrap gap-1">
                  {uniqueReasons(f.reasons).map((r) => (
                    <span
                      key={r}
                      className="pill bg-surfaceHigh text-textSecondary text-[10px]"
                    >
                      {translateReason(r)}
                    </span>
                  ))}
                </div>
              </div>
              <div className="text-right">
                <div className="text-2xl font-extrabold text-danger leading-none">
                  {f.reportCount}
                </div>
                <div className="text-[10px] uppercase tracking-widest text-textMuted mt-0.5">
                  rapor
                </div>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}

function uniqueReasons(arr: string[]) {
  return Array.from(new Set(arr));
}

function translateReason(r: string) {
  switch (r) {
    case "inappropriateName":
      return "İsim";
    case "offensiveBehavior":
      return "Saldırgan";
    case "cheating":
      return "Hile";
    case "spam":
      return "Spam";
    case "other":
      return "Diğer";
    default:
      return r;
  }
}
